// src/Components/Chart_Support_Files/chartIndicatorConfig.js

export const indexIndicators = {
  SPX: {
    defaultIndicators: [
      'SPX GEX Levels',
      'SPX Total GEX',
      'SPX GEX Trend Strength',
    ],
    prefix: 'SPX_',
  },
};

export function getGreekToIndicatorMap(symbol) {
  return {
    gamma: `${symbol} GEX Levels`,
    theta: `${symbol} Charm Levels`,
    delta: `${symbol} Delta Levels`,
    vega: `${symbol} Vanna Levels`,
  };
}
